import styled from "styled-components";
import { PanelCardPropertyWrapper } from "@sonder/ui/source/styled/fragments/PanelCardProperty";
import { colors } from "@sonder/ui/source/styled/theme";

export const PanelCard = styled.div`
  background: ${colors.white};
  box-sizing: border-box;
  color: ${colors.gray1};
  display: inline-flex;
  flex-direction: column;
  padding: 0.75rem 1.5rem;
  width: 100%;

  a {
    color: ${colors.blue7};
  }

  > ${PanelCardPropertyWrapper}:last-child {
    border-bottom: none;
  }
`;
